import { render, staticRenderFns } from "./resignationInheritance.vue?vue&type=template&id=aef360d8&scoped=true"
import script from "./resignationInheritance.vue?vue&type=script&lang=js"
export * from "./resignationInheritance.vue?vue&type=script&lang=js"
import style0 from "./resignationInheritance.vue?vue&type=style&index=0&id=aef360d8&prod&lang=less&scoped=true"
import style1 from "./resignationInheritance.vue?vue&type=style&index=1&id=aef360d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef360d8",
  null
  
)

export default component.exports